import React, { useState } from "react";
import { Box, Typography, Container, Grid, Paper } from "@mui/material";
import BalanceIcon from "@mui/icons-material/Balance";
import DescriptionIcon from "@mui/icons-material/Description";
import PersonAddIcon from "@mui/icons-material/PersonAdd";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import PhoneIcon from "@mui/icons-material/Phone";
import * as Icons from "@mui/icons-material";
import PageButton from "src/components/PageButton";



const data = [
  { icon: "SupportAgent", name: "Legal Consulting Services" ,desc:"Clear plans before making a decision to file a lawsuit."},
  { icon: "Description", name: "Contract drafting",
    desc:"Preparing and drafting contracts and agreements."
   },
  { icon: "Gavel", name: "Litigation and Dispute Resolution",
    desc:"Litigation and Dispute Resolution"
   },
   { icon: "AccountBalance", name: "Corporate Governance", desc:"Hisham Al-Sheikh & Partners Law Firm provides services for company formation, mergers, liquidation, and dissolution."},
   { icon: "HowToReg", name: "Incorporation procedures",desc:"Incorporation procedures" },
   { icon: "Business", name: "Corporate Affairs",desc:"A fruitful collaboration that relieves you of the burdens of legal management in your establishment." },
   { icon: "Translate", name: "Legal translation" ,desc:"Legal translation"},
   { icon: "Policy", name: "Internal regulations and policies",desc:"Internal regulations and policies" },
   { icon: "Groups", name: "Corporate alignment",desc:"Corporate alignment" },
   { icon: "ReportProblem", name: "Bankruptcy and reorganization proceedings",desc:"Bankruptcy and reorganization proceedings" },
   { icon: "AccountTree", name: "Division and settlement of estates",desc:"Division and settlement of estates" },
  { icon: "Balance", name: "Alternative methods of dispute resolution, mediation and arbitration",desc:"Alternative methods of dispute resolution, mediation and arbitration" },
  { icon: "TrendingUp", name: "Capital and securities market",desc:"Capital and securities market" },
  { icon: "Gavel", name: "Corporate Laws and Commercial Issues",desc:"Corporate Laws and Commercial Issues" },
  { icon: "RequestQuote", name: "Debt collection disputes",desc:"Debt collection disputes" },
  { icon: "Copyright", name: "Intellectual property and trademarks",desc:"Intellectual property and trademarks" },
  { icon: "Memory", name: "Technology Law",desc:"Technology Law" },
  { icon: "Storefront", name: "Competition and online stores",desc:"Competition and online stores" },
  { icon: "RealEstateAgent", name: "Financial and real estate issues",desc:"Financial and real estate issues" },
  { icon: "HealthAndSafety", name: "Insurance Law",desc:"Insurance Law" },
  { icon: "Assignment", name: "BOOT and FEDIC contracts",desc:"BOOT and FEDIC contracts" },
  { icon: "Public", name: "foreign investment",desc:"foreign investment" },
  { icon: "AccountBalance", name: "Administrative cases (Board of Grievances)",desc:"Administrative cases (Board of Grievances)" },
  { icon: "Work", name: "Labor Law",desc:"Labor Law" },
  { icon: "SportsSoccer", name: "Sports and media laws" ,desc:"Sports and media laws"}
]


const Step = ({ icon, title, text, stepNumber }: any) => {
  const IconComponent = Icons[icon] || Icons.HelpOutline;

  return (
    <Paper
      elevation={0}
      sx={{
        p: 4,
        textAlign: "center",
        height: '100%',
        backgroundColor: '#fff',
        borderRadius: '24px',
        border: '1px solid rgba(0,0,0,0.05)',
        boxShadow: '0 10px 40px rgba(0,0,0,0.03)',
        transition: 'transform 0.3s ease, box-shadow 0.3s ease',
        position: 'relative',
        overflow: 'hidden',
        '&:hover': {
          transform: 'translateY(-10px)',
          boxShadow: '0 20px 40px rgba(31, 93, 59, 0.12)'
        }
      }}
    >
      <Box sx={{
        position: 'absolute',
        // top: -10, 
        right: -20,
        fontSize: '120px',
        fontWeight: 900,
        color: 'rgba(31, 93, 59, 0.04)',
        lineHeight: 1,
        zIndex: 0
      }}>
        {stepNumber}
      </Box>
      <Box sx={{ position: 'relative', zIndex: 1 }}>
        <Box
          sx={{
            width: 70,
            height: 70,
            borderRadius: "16px",
            backgroundColor: "rgba(31, 93, 59, 0.1)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            color: "#1f5d3b",
            margin: "0 auto",
            mb: 3
          }}
        >
          {/* {React.cloneElement(icon, { sx: { fontSize: 35 } })} */}
          <IconComponent sx={{ fontSize: 35 }} />
        </Box>

        <Typography variant="h6" sx={{ fontWeight: 700, mb: 2, color: '#222' }}>
          {title}
        </Typography>

        <Typography
          sx={{
            fontSize: "1rem",
            color: "#666",
            lineHeight: 1.6
          }}
        >
          {text}
        </Typography>
      </Box>
    </Paper>
  )
};

const HowItWorksSection: React.FC = () => {

  const [showAll, setShowAll] = useState(false);

  const visibleData = showAll?data:data?.slice(0,6)

  return (
    <Box
      id="how-it-works"
      sx={{ background: 'linear-gradient(to bottom, #f9fafb, #ffffff)', py: { xs: 8, md: 12 } }}
    >
      <Container maxWidth="lg">
        <Box sx={{ textAlign: "center", mb: 8 }}>
          <Typography variant="overline" sx={{ color: '#1f5d3b', fontWeight: 600, letterSpacing: 2, mb: 1, display: 'block' }}>
            Learn about our services
          </Typography>
          <Typography variant="h3" sx={{ fontWeight: 700, color: '#111' }}>
            Services
          </Typography>
        </Box>

        <Grid container spacing={4} justifyContent="center">
          {
            visibleData.map((item,index) => (
              <Grid key={index} item xs={12} sm={6} md={4}>
                <Step
                  stepNumber={1}
                  icon={item?.icon}
                  title={item?.name}
                  text={item?.desc}
                />
              </Grid>
            ))
          }
<Box textAlign="center" mt={4}>
  {!showAll && <PageButton
    variant="text"
    onClick={() => setShowAll(!showAll)}
  >
    { "More ↓"}
  </PageButton>}
</Box>
        </Grid>
      </Container>
    </Box>
  );
};

export default HowItWorksSection;